import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import Report from "./Report/container";
import "./style.less";

export type MapProps = RootContainerProps & {
  hasReport: boolean;
};

export interface ActionProps {}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <Container className="wsc_content_report" {...getContainerProps(props)}>
      {props.hasReport ? <Report {...getRootContainerProps(props)} /> : i18n.infoNoReportToDisplay}
    </Container>
  );
};
